import { render, staticRenderFns } from "./CardApprovalInfo.vue?vue&type=template&id=2e72dbee&scoped=true&"
import script from "./CardApprovalInfo.vue?vue&type=script&lang=js&"
export * from "./CardApprovalInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardApprovalInfo.vue?vue&type=style&index=0&id=2e72dbee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72dbee",
  null
  
)

export default component.exports